import { useEffect, useRef } from 'react';
import { resizeFontSize } from './helpers';

export const useAutoSizeText = () => {
    const containerRef = useRef();
    const textRef = useRef();
    const { current: container } = containerRef;
    const { current: text } = textRef;

    useEffect(() => {
        if (container && text) {
            resizeFontSize({ text, container });
        }
    }, [container, text]);

    return {
        containerRef,
        textRef
    };
};
